import React from 'react';
import ToggleSwitch, { ToggleSwitchProps } from 'toggle-switch-react-native';

export default (props: ToggleSwitchProps) => {
  return <ToggleSwitch {...props} animationSpeed={100} />;
};
